/* SellerProfileDrawerContext — exposes a single shared seller-profile drawer
 * for the buyer portal. Any component can call useSellerProfileDrawer().open(slug)
 * to slide the profile in over whatever page the buyer is on. Closes via
 * backdrop click, Esc key, or the drawer's X button (all built in to Sheet).
 *
 * Scope: rendered once inside the buyer-portal route in App.js. Seller / admin
 * portals don't mount it — sellers manage their own profile inside Settings.
 */
import { createContext, useCallback, useContext, useState } from "react";
import SellerProfileDrawer from "../components/SellerProfileDrawer";

const Ctx = createContext({ open: () => {}, close: () => {} });

export function SellerProfileDrawerProvider({ children }) {
  const [slug, setSlug] = useState(null);

  const open  = useCallback((s) => { if (s) setSlug(s); }, []);
  const close = useCallback(() => setSlug(null), []);

  return (
    <Ctx.Provider value={{ open, close }}>
      {children}
      <SellerProfileDrawer slug={slug} onOpenChange={(v) => !v && close()}/>
    </Ctx.Provider>
  );
}

export function useSellerProfileDrawer() {
  return useContext(Ctx);
}
